import React from 'react';

export default function PageSubTitle(props: { title: string }) {
  return (
    <span className="text-left max-w-2xl mb-4 text-4xl font-normal tracking-tight leading-none text-blue-800 leading-snug">
      {props.title}
    </span>
  );
}
